import api from "@/services/api.service";
import { required} from 'vuelidate/lib/validators'

export default {
  name: 'add',
  components: {},
  props: [],
  data () {
    return {
      caption:"Role Add",
      campaigns:[],
      formField:{role:'',permission:{}},
      submitStatus: null,
      roles:[],
      permissions: [],
      selectedHeadersShow: [],
      permission_add: false,
      superAdmin: false          
    }
  },
  computed: {

  },
  mounted () {

  },
  validations: {
    formField: {
      role: {
        required
      }
    }
  },
  async created(){   
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_role") == true){
                this.getPermissions();
                this.permission_add = permissions.includes("add_role");
            }else if(response.data[0].role == 'super_admin'){
              this.getPermissions();
              this.superAdmin = true;
            }else if(permissions.includes("list_role") == true || permissions.includes("add_role") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Roles List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }   
  },
  methods: {
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },
    async getPermissions() {
      
      var response = await  api.post('role-permission/permission-list')
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
      if (response.status == 'success') {
        if (response.data != '') {          
          response.data.forEach(function(e){                      
            this.permissions.push({value:e.id,text:e.label});
          }.bind(this));                    
        } else {
          this.permissions = [];
          this.makeToast(`No permissions found.`, 'Alert', 'danger')
        }      
      } else
      this.makeToast(`No permissions found.`, 'Alert', 'danger')
    },
    selectedHeaders(index) {
      if (this.selectedHeadersShow.includes(this.permissions[index].value)) {
        this.selectedHeadersShow.splice(
          this.selectedHeadersShow.indexOf(this.permissions[index].value),
          1
          );
      } else {
        this.selectedHeadersShow.push(this.permissions[index].value);
      }
    },          
    async save(){
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = true
      } else{
        if (this.selectedHeadersShow.length === 0) {
        this.makeToast("Please, select any columns","Alert","danger",6000);
        return;
      }
        this.formField.permission = this.selectedHeadersShow;
       
        let response = await api.post('/role-permission/add', this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

        if(response.status=='success'){
          this.makeToast(response.message,'Success','success');
          this.$router.push({name:"Roles List"})
        }else{
          // for(var error in response.message){
            this.makeToast(response.message,'Alert','danger');
          // }
        }

      }
    }
  }
}


